// components/Header.js
import React from 'react';
import { getCurrentUser, logout } from '../services/AuthService';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';

const Header = () => {
  const user = getCurrentUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // JWT'den gelen name değerinin ilk harfini al
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : '';
  };

  return (
    <nav className="navbar navbar-expand navbar-dark bg-primary">
      <div className="container-fluid">
        <span className="navbar-brand">HarmonySense Admin</span>

        {user && (
          <div className="d-flex align-items-center ms-auto">
            <div
              className="text-white rounded-circle bg-secondary d-flex justify-content-center align-items-center me-2"
              style={{ width: '35px', height: '35px', fontSize: '14px' }}
            >
              {getInitial(user.name)}
            </div>

            <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>
              <FiLogOut size={18} />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;